import { useDndMonitor } from '@dnd-kit/core';
import { memo } from 'react';
import { GanttComponent } from './GanttComponent';
import { useGanttProductionPlan, useSyncGanttFilterStoreWithQueryParams } from '../hooks';
import { useGroupedQueuesStore, visibleQueuesSelector } from '../store';
import { ProductionPlanEmptyState } from '../ProductionPlanEmptyState';
import { useGanttOnDragEnd } from './hooks';

export const Gantt = memo(() => {
  const onDragEnd = useGanttOnDragEnd();

  useDndMonitor({
    onDragEnd,
  });

  useGanttProductionPlan();
  useSyncGanttFilterStoreWithQueryParams();

  const isAllQueuesHidden = useGroupedQueuesStore((state) => visibleQueuesSelector(state).length === 0);

  if (isAllQueuesHidden) {
    return <ProductionPlanEmptyState />;
  }

  return <GanttComponent />;
});

Gantt.displayName = 'Gantt';
